import { renderReact } from "hypernova-react";
import BurgerMenu from "web/react/components/burger-menu/burger-menu";
import CookieBannerVariation from "web/react/components/cookie-banner/cookie-banner-variation";
import EmailCaptureOverlay from "web/react/components/email-capture-overlay/email-capture-overlay";
import FollowStickyBanner from "web/react/components/follow-sticky-banner/follow-sticky-banner";
import Hint from "web/react/components/hint/hint";
import ProductArea from "web/react/components/product-area/product-area";
import ProductDescription from "web/react/components/product-description/product-description";
import ProductGallery from "web/react/components/product-gallery/product-gallery";
import RecentlyViewedEmailCapture from "web/react/components/recently-viewed-email-capture/recently-viewed-email-capture";
import SearchButton from "web/react/components/search-button/search-button";
import DesignerExitTrigger from "web/react/components/designer-exit-trigger/designer-exit-trigger";
import withRedux from "web/react/redux-provider";

export function initialiseReact() {
    renderReact("BurgerMenu.jsx", BurgerMenu);
    renderReact("CookieBannerVariation.jsx", CookieBannerVariation);
    renderReact("EmailCaptureOverlay.jsx", EmailCaptureOverlay);
    renderReact("FollowStickyBanner.jsx", FollowStickyBanner);
    renderReact("Hint.jsx", Hint);
    renderReact("ProductDescription.jsx", withRedux(ProductDescription));
    renderReact("ProductArea.jsx", withRedux(ProductArea));
    renderReact("ProductGallery.jsx", ProductGallery);
    renderReact("RecentlyViewedEmailCapture.jsx", RecentlyViewedEmailCapture);
    renderReact("SearchButton.jsx", SearchButton);
    renderReact("DesignerExitTrigger.jsx", DesignerExitTrigger);
}
